
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4L14 3V19L12 20V4ZM11.5 10.0661C9.75123 10.2217 8.15699 10.6467 6.89593 11.2772C5.34191 12.0542 4 13.3127 4 15C4 16.5599 5.15316 17.7548 6.53007 18.5289C7.84813 19.2699 9.58692 19.7638 11.5 19.9341V17.9251C9.87994 17.7606 8.4937 17.3385 7.5102 16.7856C6.37368 16.1466 6 15.48 6 15C6 14.4783 6.44895 13.7368 7.79036 13.066C8.75473 12.5839 10.0356 12.2237 11.5 12.075V10.0661ZM17.0026 12.5812C16.2631 12.3445 15.4182 12.1682 14.5 12.075V10.0661C16.0916 10.2078 17.5581 10.5727 18.7621 11.1149L19.5 10.5L20.5 14L16.5 13L17.0026 12.5812Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowOpenidFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
